import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/contexts/AuthContext";

export default function SocialAccountCallback() {
  const { provider } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const started = useRef(false);
  const [message, setMessage] = useState("Completing account connection…");
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const code = params.get("code");
    const state = params.get("state");
    const denied = params.get("error");
    // Remove bearer-like callback data from the address bar immediately.
    window.history.replaceState(window.history.state, "", window.location.pathname);
    if (!["x", "tiktok"].includes(provider) || denied || !code || !state) {
      setMessage("The account was not connected. You can start again from Marketing & Content.");
      return;
    }
    axios.post(`${API}/social/accounts/${provider}/callback`, { code, state })
      .then(({ data }) => {
        setMessage(data?.ok ? "Account connected. Return to Marketing & Content to view it."
          : "The connection could not be confirmed. Start a new connection request.");
      }).catch(() => {
        setMessage("The connection could not be completed. Start a new connection request from Marketing & Content.");
      });
  }, [provider, params]);
  return (
    <section className="max-w-xl mx-auto my-12 rounded-2xl bg-white border p-6">
      <h1 className="text-xl font-semibold">Social account connection</h1>
      <p role="status" className="mt-3 text-sm">{message}</p>
      <button className="zy-btn-outline mt-5" onClick={() => navigate("/dashboard/marketing", { replace: true })}>
        Back to Marketing &amp; Content
      </button>
    </section>
  );
}
